<template>
  <div>
    <!--カレンダー名と編集ボタン-->
    <div>
      <span
        class="boss-interview-candidate-date-schedule-name"
        data-test="schedule-name"
      >{{ schedule.name }}</span>
      <button
        class="float-right boss-button boss-interview-candidate-date-schedule-button"
        data-test="edit-button"
        @click="$router.push({ name: 'interviewCandidateDateEdit', params: { id: schedule.id } })"
      >
        <span class="boss-icon-pencil" />
        <span class="boss-button-new-text">編集する</span>
      </button>
    </div>
    <!--設定可能日10日分表示-->
    <div
      v-if="!isPublishing"
      class="boss-interview-candidate-date-schedule-text-parent"
      data-test="not-publishing"
    >
      <p class="boss-interview-candidate-date-schedule-text-child">
        掲載中、あるいは今後掲載予定の求人がある場合に、日程が表示されます。
      </p>
    </div>
    <div
      v-else-if="!isLinkedJob"
      class="boss-interview-candidate-date-schedule-text-parent"
      data-test="not-Linked-job"
    >
      <p class="boss-interview-candidate-date-schedule-text-child">
        応募者へ表示されていません。<br>利用する場合は求人設定で<br>カレンダーを選択してください。
      </p>
    </div>
    <div
      v-else
      class="boss-interview-candidate-date-schedule-display-dates"
      data-test="displayDate"
    >
      <div
        v-for="(displayDate, j) in schedule.displayDates"
        :key="`display-date-${j}`"
      >
        <div
          class="boss-interview-candidate-date-schedule-display-date"
          :data-test="`display-date-${j}`"
        >
          {{ j + 1 }}. {{ displayDate | formatDate }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd)') : defaultLabel
    }
  },
  props: {
    schedule: {
      type: Object,
      required: true
    },
    isPublishing: {
      type: Boolean,
      required: true
    },
    isLinkedJob: {
      type: Boolean,
      required: true
    }
  }
}
</script>
